// Affichage fr-CH : montants à deux décimales, dates jj.mm.aaaa, mois en toutes lettres.
const fmtChf = new Intl.NumberFormat('fr-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDate = new Intl.DateTimeFormat('fr-CH', { day: '2-digit', month: '2-digit', year: 'numeric' });
const fmtMois = new Intl.DateTimeFormat('fr-CH', { month: 'long', year: 'numeric' });

export const chf = (n: number) => fmtChf.format(n);
export const dateCourte = (iso: string | null | undefined) => (iso ? fmtDate.format(new Date(`${iso.slice(0, 10)}T00:00:00`)) : '—');
export const moisLabel = (m: string) => fmtMois.format(new Date(`${m}-01T00:00:00`));
export const aujourdhui = () => new Date().toISOString().slice(0, 10);
export const debutMois = (iso = aujourdhui()) => `${iso.slice(0, 7)}-01`;
export const moisPrecedent = () => {
  const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1);
  const du = d.toISOString().slice(0, 10);
  const fin = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  return { du, au: `${fin.getFullYear()}-${String(fin.getMonth() + 1).padStart(2, '0')}-${String(fin.getDate()).padStart(2, '0')}` };
};

/** Classe du montant selon son signe : négatif = doit, positif = avoir. */
export const soldeClass = (n: number) => (n < -0.004 ? 'montant is-doit' : n > 0.004 ? 'montant is-avoir' : 'montant is-zero');

export const LIBELLE_MOYEN: Record<string, string> = { cash: 'Cash', virement: 'Virement', facture: 'Facture', autre: 'Autre' };
export const LIBELLE_STATUT: Record<string, string> = { brouillon: 'Brouillon', envoyee: 'Envoyée', payee: 'Payée', annulee: 'Annulée' };
export const badgeStatut = (s: string) => (s === 'payee' ? 'badge badge-ok' : s === 'envoyee' ? 'badge badge-warn' : s === 'annulee' ? 'badge badge-err' : 'badge');
